// Import model
import { FileFieldOptions } from '../models/FileFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FileFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class FileFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a FileFieldOptions instance
   */
  static deserialize(json: string): FileFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FileFieldOptions instance
   */
  static fromObject(obj: any): FileFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FileFieldOptions');
    }


    const instance: FileFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      contentTypes: obj['ContentTypes'] ? (obj['ContentTypes'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FileFieldOptions instances
   */
  static deserializeArray(json: string): FileFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FileFieldOptions instance to a JSON string
   */
  static serialize(instance: FileFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FileFieldOptions instance to a plain object
   */
  static toObject(instance: FileFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'ContentTypes': instance.contentTypes?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of FileFieldOptions instances to a JSON string
   */
  static serializeArray(instances: FileFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
